export default __webpack_public_path__ + "static/media/icon-print.f5dd47cc.svg";